import { Middleware } from 'redux';
// Remove RootState import since it's not used
import { logout } from '../slices/authSlice';

export const authMiddleware: Middleware = store => next => (action: unknown) => {
  // Handle token expiration
  if (typeof action === 'object' && action !== null && 
      'type' in action && 'payload' in action &&
      typeof action.type === 'string' && 
      action.type.endsWith('/rejected') && 
      typeof action.payload === 'object' && action.payload !== null &&
      'status' in action.payload && action.payload.status === 401) {
    
    // Store error message for user-friendly display
    localStorage.setItem('auth_error', 'Your session has expired. Please log in again.');
    
    // Dispatch logout action
    store.dispatch(logout());
    
    // Don't immediately redirect - let components handle this
    // This allows for better UX with proper error messages
  }
  
  return next(action);
};